import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function NodeTechPage() {
  return <TechnologyDetailPage slug="node-js" />;
}